/**
 * Export a CSV — el ÚNICO camino (auditoría 18/09/2026: había 5 exportadores,
 * 4 sin protección contra fórmulas y con separadores distintos).
 *
 * Seguridad: una celda que empieza con `=`, `+`, `-`, `@`, tab o CR se ejecuta
 * como fórmula al abrir el archivo en Excel/Sheets. Las evidencias del Mapa de
 * Talento, las aspiraciones de D-Talk y las notas del Vault las escribe
 * cualquier clapper: `csvCell` les antepone un apóstrofo. Regla original en
 * learning-dash-utils.ts (People Learning), ahora compartida.
 */

export function csvCell(v: unknown): string {
  let str = String(v ?? '');
  if (/^[=+\-@\t\r]/.test(str)) str = `'${str}`;
  return `"${str.replace(/"/g, '""')}"`;
}

export interface DownloadCsvOptions {
  /** `,` por default (Sheets/Excel lo detectan); People Learning usa `;`. */
  delimiter?: ',' | ';';
}

/** Arma el archivo (BOM UTF-8 para que Excel lea las tildes) y dispara la descarga. */
export function downloadCsv(filename: string, headers: string[], rows: unknown[][], opts: DownloadCsvOptions = {}): void {
  const sep = opts.delimiter ?? ',';
  const line = (cells: unknown[]) => cells.map(csvCell).join(sep);
  const csv = '﻿' + [line(headers), ...rows.map(line)].join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' }); // reuse-ok: este ES el exportador compartido
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 400);
}
